<template src="./template/index.html">

</template>
<script>
import { getDonationRequestData } from '@/services/services.js'
import DibbleAPI from '../../api'
import {PATH} from '@/constant/Path.js'
import DibbleJS from "@/dibble";
import DibbleJs from '@/dibble'
import DibbleApi from '../../api'

export default {
    data () {
        return {
            request_id: null,
            donationData: null,
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            note: '',
            amountOptions: [],
            amountSelected: '',
            isAnonymous: false,
            isShowOther: false,
            maxLength: 1000,
            
            isNotCoveredFee: false,
            isDonateAsOrganization: false,
            organizationName: '',
            
            address: '',
            address2: '',
            city: '',
            state: '',
            zipCode: '',
            country: 'US',
            
            country_list: [],
            stateOutsideUS: [
                {
                    value: '',
                    label: 'Outside of the US',
                },
            ],
            previous_state: '',
            states: [],
            tilled: null,
            form: null,
            isFormValid: false,
        }
    },
    created() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.request_id = this.$route.params.id;
    },
    methods: {
        getCountryCodes() {
            const params = {
                '#request': DibbleApi.api.getCountryCodes,
            };
            DibbleJS.callApiRequest(params, (response) => {
                if (response.rc === 0) {
                    const { countries } = response;
                    if (countries.length) {
                        this.country_list = countries.map((item) => ({
                            value: item.country_code,
                            label: item.name,
                        }));
                    }
                }
            }, false, false);
        },
        getStates() {
            const params = {
                '#request': DibbleApi.api.getStateList,
            };
            DibbleJS.callApiRequest(params, (response) => {
                if (response.rc === 0) {
                    const { states } = response;
                    if (states.length) {
                        this.states = states.map((item) => ({
                            value: item.state_code,
                            label: item.name,
                        }));
                    }
                }
            }, false, false);
        },
        isNumber (evt) {
            if (evt.key === '+')
                return true;
            
            evt = (evt) || window.event
            const charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault()
            } else {
                return true
            }
        },
        getDonationRequestData () {
            getDonationRequestData(this.request_id)
                .then(res => {
                    if (DibbleAPI.isResponseSuccess(res.data)) {
                        this.donationData = res.data
                        
                        this.firstName = res.data.first_name
                        this.lastName = res.data.last_name
                        this.email = res.data.email
                        this.phone = res.data.phone
                        this.maxLength = res.data.max_note_len
                        
                        this.amountSelected = res.data.amount
                    } else {
                        DibbleJS.toastErrorMessage(res.data.message)
                    }
                })
        },
        selectAmount (amount) {
            this.amountSelected = +amount
            this.isShowOther = false
        },
        checkAnonymous () {
            this.isAnonymous = !this.isAnonymous
        },
        checkNotCoveredFee () {
            this.isNotCoveredFee = !this.isNotCoveredFee
        },
        checkDonateAsOrganization () {
            this.isDonateAsOrganization = !this.isDonateAsOrganization
        },
        showOther () {
            this.amountSelected = ''
            this.isShowOther = true
            this.$nextTick(() => this.$refs.inputOther.focus())
        },
        formatCurrency (value) {
            if (value) {
                return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
        },
        async initTilled() {
            this.tilled = new window.Tilled(this.donationData.public_key, this.donationData.account_id, { sandbox: this.donationData.is_sandbox });
            
            this.form = await this.tilled.form({ payment_method_type: 'card' });
            
            // Style a Form Field
            const fieldOptions = {
                styles: {
                    base: {
                        fontFamily: 'Helvetica Neue, Arial, sans-serif',
                        fontWeight: '400',
                        fontSize: '16px',
                        background: 'none',
                        color: '#7c7c7a',
                        paddingInline: '16px',
                        width: '100%',
                        border: '1px solid #7c7c7a',
                        borderRadius: '8px',
                        height: '30px',
                    },
                    invalid: {
                        ':hover': {
                            textDecoration: 'underline dotted red',
                        },
                        color: 'red',
                    },
                    valid: {
                        color: '#00BDA5',
                    },
                },
            };
            
            this.form.createField('cardNumber', {...fieldOptions, placeholder: 'Card num'}).inject('#cardNumber');
            this.form.createField('cardExpiry', {...fieldOptions, placeholder: 'Card exp'}).inject('#cardExp');
            this.form.createField('cardCvv', {...fieldOptions, placeholder: 'CVV'}).inject('#cardCvv');
            
            await this.form.build();
            this.form.on("validation", (event) => {
                if (event.field) {
                    event.field.element.classList.remove('success', 'error')
                    event.field.element.classList.add(event.field.valid ? 'success' : 'error')
                }
                
                this.isFormValid = this.form.valid
            });
        },
        checkForTilledPaymentStatus(secret) {
            const params = {
                '#request': DibbleApi.api.tilledGetPaymentStatus,
                campaign_id: this.donationData.campaign_id,
                client_secret: secret
            }
            
            DibbleJs.callApiRequest(params, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    if (!response.is_failed) {
                        DibbleJS.setUID(this.donationData.campaign_id);
                        this.$router.push(PATH.THANK_YOU)
                    } else {
                        DibbleJs.toastErrorMessage(response.fail_message)
                    }
                } else {
                    DibbleJs.toastErrorMessage(response.message)
                }
                DibbleJs.hideLoader()
            }, false, false);
        },
        async confirmPayment(secret, phone_number) {
            console.log('Creating one time payment...')
            const params = {
                payment_method: {
                    billing_details: {
                        name: `${this.firstName} ${this.lastName}`,
                        email: this.email,
                        phone: phone_number,
                        address: {
                            city: this.city,
                            country: this.country,
                            street: this.address,
                            street2: this.address2,
                            zip: this.zipCode,
                            state: (this.country.toLowerCase() == "us" ? this.state : 'XX'),
                        },
                    },
                }
            }
            
            try {
                const payment = await this.tilled.confirmPayment(secret, params);
                console.log('Successful payment');
                console.log(payment)
                this.checkForTilledPaymentStatus(secret)
            } catch (e) {
                console.log('Failed to confirm payment');
                console.log(e)
                DibbleJs.toastErrorMessage(e)
                DibbleJs.hideLoader()
            }
        },
        performValidation() {
            const params = {
                campaign_id: this.donationData.campaign_id,
                donation_request_id: this.request_id,
                amount: this.amountSelected,
                first_name: this.firstName,
                last_name: this.lastName,
                business_name: this.organizationName,
                email: this.email,
                phone_num: this.phone,
                dedication: this.note,
                is_anonymous: this.isAnonymous,
                is_cover_fees: !this.isNotCoveredFee,
                
                designation_id: '',
                address1: this.address,
                address2: this.address2,
                city: this.city,
                state: this.state,
                zip_code: this.zipCode,
                country: this.country,
                comment: '',
                is_monthly: false,
            }
            
            DibbleJs.showLoader();
            const data = {
                '#request': DibbleApi.api.donationWithTilled,
                ...params,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    const { client_secret, phone_number } = response;
                    this.confirmPayment(client_secret, phone_number);
                } else {
                    DibbleJs.toastErrorMessage(response.message)
                    DibbleJs.hideLoader();
                }
                
            }, false, false);
        },
    },
    mounted () {
        this.getCountryCodes()
        this.getStates()
        
        let tilledScript = document.createElement('script')
        tilledScript.setAttribute('src', 'https://js.tilled.com/v2')
        document.head.appendChild(tilledScript)
        
        setTimeout(() => {
            this.initTilled()
        }, 3000)
    },
    watch: {
        request_id(val) {
          if (val) {
              this.getDonationRequestData()
          }
        },
        country(value) {
            if (value !== 'US') {
                this.previous_state = this.state;
                this.state = '';
            } else {
                this.state = this.previous_state;
            }
        },
    },
    computed: {
        stateOptions() {
            return this.country === 'US' ? this.states : this.stateOutsideUS;
        },
        isDisabledStateOptions() {
            return this.country !== 'US';
        },
        checkDisabled () {
            return this.isFormValid
                && this.firstName && this.lastName && this.email  && this.amountSelected && this.phone
                && this.address && this.city && this.zipCode && (this.country === 'US' ? this.state : true);
        },
        fee() {
            return this.donationData
                ? (this.isNotCoveredFee ? 0 : this.donationData.transaction_fee + Math.round(parseInt(this.amountSelected) * this.donationData.discount_fee_pc) / 100)
                : 0;
        },
        isTilledValid() {
            return this.form ? this.form.valid : false;
        }
    }
}
</script>
<style scoped lang="scss">
    .donate-page-bg {
      height: 150% !important;
    }
    .select-amount-wrap {
      cursor: pointer;
      border-radius: 40px !important;
      border: 1px solid #00cfff !important;
      strong {
        border: none !important;
      }
      &:hover {
        background-color: #00cfff;
        border-color: #00cfff;
      }
      a {
        border-radius: 40px;
        
        &:hover {
          background-color: transparent !important;
          border: none !important;
        }
      }
    }
    .tilled-field {
        border: 1px solid #bcbec0;
        background-color: #fff;
        border-radius: 15px;
        margin-bottom: 20px;
        display: inline-block;
        width: 100%;
        height: 51px;
        outline: none;
        padding: 10px;
    }
</style>
